import { useApi } from '@/composables/useApi'

const api = useApi()

const getUsuarioById = (IdUser, TypeDate = '') => new Promise((resolve, reject) => {
  try {
    const params = TypeDate !== null ? TypeDate : {}
    api.get(`/users/${IdUser}`, {
      params,
    })
      .then(res => {
        resolve(res.data)
      })
  } catch (error) {
    reject(error)
  }
})

const deletedUsuarioById = IdUser => new Promise((resolve, reject) => {
  try {
    api.delete(`/users/${IdUser}`)
      .then(res => {
        resolve(res.data)
      })
  } catch (error) {
    reject(error)
  }
})

export {
  getUsuarioById,
  deletedUsuarioById,
}
